import { render, staticRenderFns } from "./OverdueRecallSkeleton.vue?vue&type=template&id=576a3aaa&scoped=true"
import script from "./OverdueRecallSkeleton.vue?vue&type=script&lang=js"
export * from "./OverdueRecallSkeleton.vue?vue&type=script&lang=js"
import style0 from "./OverdueRecallSkeleton.vue?vue&type=style&index=0&id=576a3aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576a3aaa",
  null
  
)

export default component.exports